module.exports = __webpack_public_path__ + "media/images/about-hero-shadow-99a7cf8f846bf3a95950611d075bca7b.png";